import { Spinner } from 'react-bootstrap';
import './loading.component.scss';

export function Loading(props: { show: boolean; rounded?: boolean }): React.ReactElement {
  return (
    <div className={`sl-loading ${props.show ? 'sl-loading--visible' : ''} ${props.rounded === false ? '' : 'rounded'}`}>
      <Spinner animation="border" variant="primary" />
    </div>
  );
}
